export enum NotificacaoGrupoSegmentoMercadoEnum {
    TODOS = 1,
    FILMES_SERIES_PROGRAMAS_NOVELAS = 2,
    JOGOS_ELETRONICOS_APLICATIVOS_RPG = 3,
}
